import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";

import store, {
  deleteBlock,
  doToSelected,
  duplicateBlock,
  toggleLock,
  toggleVisibility,
  bringBlockToFront,
  sendBlockToBack,
  duplicateCurrentScene,
  printCurrentScene
} from "../canvas/store";
import Properties from "../properties/index";
import { deleteCurrentScene } from "../user/index";

import * as Icons from "../reusable/icons";
import * as Colors from "../reusable/colors";
import { HCenter, VCenter, Divider, ShowWhen } from "../reusable/layout";
import { headerHeight } from "./header";
import { HeaderAction, ActionIcon } from "../reusable/components";

// onAddSlide={() => this.props.addSlide(this.props.selected)}
//         onResetAspectRatio={() => this.resetAspectRatio(this.props.selected)}
//         spreadsheet={this.props.spreadsheet

const FooterActionLabel = styled.div`
  text-transform: uppercase;
  padding: 7px 9px;
  background-color: ${Colors.primary};
  border-radius: 5px;
  font-size: 0.8em;
`;

const rightMenuWidth = "340px";
const RightMenu = styled.div`
  height: 100%;
  width: ${rightMenuWidth};
  flex: 0 0 ${rightMenuWidth};
  background-color: ${Colors.secondary};
  z-index: 40;
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${Colors.separatorDark};
`;

const RightMenuTitle = styled.h2`
  ${VCenter};
  ${HCenter};
  font-size: 2.5em;
  flex: 0 0 ${headerHeight}px;
  color: ${Colors.Text};
`;

const RightMenuContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

const RightMenuFooter = styled.div`
  flex: 0 0 200px;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  border-top: 2px solid ${Colors.primary};
`;

const ElementAction = ({ label, Icon, onClick }) => (
  <HeaderAction onClick={onClick}>
    <ActionIcon>
      <Icon />
    </ActionIcon>
    <Divider h="8px" />
    <FooterActionLabel>{label}</FooterActionLabel>
    <Divider h="18px" />
  </HeaderAction>
);

export default observer(props => (
  <RightMenu>
    <RightMenuTitle>Properties.</RightMenuTitle>
    <RightMenuContent>
      <Properties />
    </RightMenuContent>
    <Divider h="20px" />
    <ShowWhen pred={store.selected !== "canvas"}>
      <RightMenuFooter>
        <ElementAction onClick={doToSelected(deleteBlock)} Icon={Icons.Delete} label="delete" />
        <Divider w="25px" />
        <ElementAction
          onClick={doToSelected(duplicateBlock)}
          Icon={Icons.Duplicate}
          label="duplicate"
        />
        <Divider w="25px" />
        <ElementAction
          onClick={doToSelected(toggleVisibility)}
          Icon={Icons.Hide}
          label={store.selectedBlock.hidden ? "show" : "hide"}
        />
        <Divider w="25px" />
        <ElementAction
          onClick={doToSelected(bringBlockToFront)}
          Icon={Icons.BringFront}
          label="to front"
        />
        <Divider w="25px" />
        <ElementAction
          onClick={doToSelected(sendBlockToBack)}
          Icon={Icons.SendBack}
          label="to back"
        />
        <Divider w="25px" />
        <ElementAction
          onClick={doToSelected(toggleLock)}
          Icon={Icons.Lock}
          label={store.selectedBlock.locked ? "unlock" : "lock"}
        />
      </RightMenuFooter>
    </ShowWhen>
    <ShowWhen pred={store.selected === "canvas"}>
      <RightMenuFooter>
        <ElementAction onClick={deleteCurrentScene} Icon={Icons.Delete} label="delete" />
        <Divider w="20px" />
        <ElementAction onClick={duplicateCurrentScene} Icon={Icons.Clone} label="duplicate" />
        <Divider w="20px" />
        <ElementAction onClick={printCurrentScene} Icon={Icons.Clone} label="Print" />
      </RightMenuFooter>
    </ShowWhen>
  </RightMenu>
));



// WEBPACK FOOTER //
// ./src/layout/detail.js